import React from 'react';

import { bemBlock } from '@neptune/shared/venus-ui';

import { MiddleEllipsis } from '../middle-ellipsis/ui/MiddleEllipsis';

import { Comparison } from './Comparison';
import { diffStrings, Token } from './diff';

import './TextDiff.less';

const block = bemBlock('text-diff');

export const TextDiff: React.FC<{
  limit?: number;
  value: string;
  referenceValue: string;
  onTruncationChange?: (isTruncated: boolean) => void;
  textDiffRef?: React.RefObject<HTMLSpanElement>;
}> = ({ limit, value, referenceValue, onTruncationChange, textDiffRef }) => {
  const skipDiffHighlighting =
    !!limit && (value === referenceValue || value.length > limit || referenceValue.length > limit);

  const tokens = React.useMemo<Token[]>(
    () => (skipDiffHighlighting ? [] : diffStrings(value, referenceValue)),
    [skipDiffHighlighting, value, referenceValue],
  );

  if (skipDiffHighlighting) {
    return (
      <div className={block({ modifiers: { empty: !value } })}>
        <MiddleEllipsis text={value} onTruncationChange={onTruncationChange} />
      </div>
    );
  }

  return (
    <span ref={textDiffRef} data-role="text-diff">
      <Comparison tokens={tokens} />
    </span>
  );
};
